import React, { useState, useEffect } from 'react'

import { SearchOutlined } from '@ant-design/icons'
import { Input, AutoComplete } from 'antd'
import { get, flatten } from 'lodash'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getSearch } from '../redux/actions/search'

const Search = (props) => {
  const [options, setOptions] = useState([])
  const [text, setText] = useState('')
  const history = useHistory()
  const { i18n } = useTranslation()
  const dispatch = useDispatch()

  const [searchContent] = useSelector((state) => [get(state, 'search.data', {})])

  const onSelect = (value, option) => {
    history.push(`/category/${option.key}`)
  }

  const handelOnPressEnter = (e) => {
    const value = e.target?.value
    history.push(`/search-result?searchtext=${value}`)
  }

  useEffect(() => {
    if (text) {
      const content = flatten(searchContent).map((v) => ({
        label: v.title ? v.title : v.label,
        value: v.title ? v.title : v.label,
        key: v.mergeSlug,
      }))
      setOptions(content)
    } else {
      setOptions([])
    }
  }, [text, searchContent])

  const onSearch = (searchtext) => {
    if (searchtext) {
      dispatch(getSearch(i18n.language, searchtext))
    }
    setText(searchtext)
  }

  return (
    <div className="search-btn">
      <AutoComplete
        dropdownClassName="certain-category-search-dropdown"
        style={{
          width: '100%',
        }}
        options={options}
        onSelect={onSelect}
        onSearch={onSearch}
      >
        <Input
          allowClear
          defaultValue={props.searchtext}
          size="large"
          bordered={false}
          placeholder={props.placeholder}
          prefix={<SearchOutlined style={{ padding: '0px 8px' }} />}
          onPressEnter={handelOnPressEnter}
        />
      </AutoComplete>
    </div>
  )
}

Search.propTypes = {
  placeholder: PropTypes.string,
  searchtext: PropTypes.string,
}

Search.defaultProps = {
  placeholder: '',
  searchtext: '',
}

export default Search
